module.exports = __webpack_public_path__ + "img/hm.53942d2f.svg";